export default "__VITE_ASSET__Dw0TR0aJ__"